import React, { useCallback, useEffect, useRef, useState } from 'react';
import clsx from 'clsx';

import { API, api } from 'modules/api';
import { clearCache, getDateFormatted } from 'modules/utils/utils';
import { Header } from '../Header/';
import { MOBILE_SML } from 'modules/utils/constants';
import { useMediaQuery } from 'react-responsive';
import { ReactComponent as Bookmarked } from 'modules/theme/icons/misc/card-bookmarked.svg';
import { ReactComponent as Like } from 'modules/theme/icons/misc/card-no-like.svg';
import { ReactComponent as Liked } from 'modules/theme/icons/misc/card-like.svg';
import { ReactComponent as NoBookmarked } from 'modules/theme/icons/misc/card-no-bookmarked.svg';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

type TopPanelType = {
  meta: any;
  title: string;
  image: any;
  tags: any;
  likes: number;
  liked: boolean;
  bookmarked: boolean;
  contentTypeUid: string;
  cmspage: any;
};

export const TopPanel: React.FunctionComponent<TopPanelType> = ({
  meta,
  title,
  image,
  tags,
  likes = 0,
  liked,
  contentTypeUid,
  bookmarked,
  cmspage,
}) => {
  // const {
  //   timestamp,
  //   // author: [
  //   //   { title: title_author = '', bio = '', image: authorImage = {} } = {},
  //   // ],
  // } = meta;
  const isMobile = useMediaQuery({
    query: `(max-width:${MOBILE_SML})`,
  });
  const className = clsx(
    styles.authorContainer,
    image.use_video && styles.siblingVideo,
  );
  const [pageLiked, setPageLiked] = useState(liked);
  const [pageLikes, setPageLike] = useState(likes);
  const [pageBookmarked, setPageBookmarked] = useState(bookmarked);
  const active = useRef(true);

  //TODO done useCallback
  const postLike = useCallback(
    async (newLikeValue: boolean) => {
      try {
        setPageLiked(newLikeValue);
        if (newLikeValue) {
          setPageLike(pageLikes + 1);
        } else {
          setPageLike(pageLikes - 1);
        }
        await api(
          API.POST_LIKE_CONTENT_TYPE({
            ContentTypeUid: cmspage?.metaDataModels[0].windowTitle,
            Liked: newLikeValue,
          }),
        );
        active.current && clearCache();
      } catch (error) {
        if (active.current) {
          setPageLiked(!newLikeValue);
          if (newLikeValue) {
            setPageLike(pageLikes - 1);
          } else {
            setPageLike(pageLikes + 1);
          }
        }
      }
    },
    [contentTypeUid, pageLikes],
  );

  //TODO done useCallback
  const postBookmark = useCallback(
    async (newBookmarkValue: boolean) => {
      try {
        setPageBookmarked(newBookmarkValue);
        await api(
          API.POST_BOOKMARK_CONTENT_TYPE({
            ContentTypeUid: cmspage?.metaDataModels[0].windowTitle,
            Liked: newBookmarkValue,
          }),
        );
        active.current && clearCache();
      } catch (error) {
        active.current && setPageBookmarked(!newBookmarkValue);
      }
    },
    [contentTypeUid],
  );

  useEffect(() => {
    return () => {
      active.current = false;
    };
  }, []);

  return (
    <header className={styles.topPanel}>
      {cmspage.datesModels.length > 0 && (
        <div className={styles.publication}>
          <time dateTime={cmspage?.datesModels[0].date}>
            {getDateFormatted(cmspage?.datesModels[0].date)}
          </time>
          <p>{cmspage?.datesModels[0].dateLabel}</p>
        </div>
      )}
      <ul aria-label="Article tags" className={styles.tags}>
        {tags?.map((tag: any, index: number) => {
          return <li key={`top-panel-tag-${index}`}>{tag}</li>;
        })}
      </ul>
      <h1>
        <span>{title}</span>
      </h1>
      <div className={styles.social}>
        <div className={styles.likes}>
          <div className={styles.roundel} onClick={() => postLike(!pageLiked)}>
            {pageLiked ? <Liked /> : <Like />}
          </div>
          {pageLikes > 0 && (
            <span>
              {pageLikes > 1 ? `${pageLikes} Likes` : `${pageLikes} Like`}
            </span>
          )}
        </div>
        <div
          className={styles.roundel}
          onClick={() => postBookmark(!pageBookmarked)}
        >
          {pageBookmarked ? (
            <Bookmarked className={styles.bookmarkIcon} />
          ) : (
            <NoBookmarked className={styles.bookmarkIcon} />
          )}
        </div>
      </div>
      {cmspage?.imageModels !== null && cmspage?.imageModels.length > 0 && (
        <Header image={cmspage.imageModels[0].imageUrl} />
      )}
      {cmspage?.imageModels !== null && cmspage?.imageModels.length > 0 && (
        <div className={styles.author}>
          <div className={className}>
            {/* {cmspage.imageModels[0].imageUrl && (
              <div
                className={styles.avatar}
                style={{
                  backgroundImage: `url(${cmspage.imageModels[0].imageUrl}`,
                }}
              ></div>
            )} */}
            <div>
              {cmspage?.imageModels?.length > 0 &&
                cmspage?.imageModels[0]?.title !== ' ' && (
                  <p>
                    Author:
                    <span
                      dangerouslySetInnerHTML={{
                        __html: cmspage.imageModels[0].title,
                      }}
                    ></span>
                  </p>
                )}
              {!isMobile &&
                cmspage?.imageModels[0]?.description &&
                cmspage?.imageModels[0]?.description !== ' ' &&
                cmspage?.imageModels[0]?.description !== '<p> </p>' && (
                  <p
                    style={{ fontWeight: 'normal' }}
                    dangerouslySetInnerHTML={{
                      __html: cmspage.imageModels[0].description,
                    }}
                  ></p>
                )}
            </div>
          </div>
          {isMobile &&
            cmspage?.imageModels[0]?.description &&
            cmspage?.imageModels[0]?.description !== '<p> </p>' && (
              <p
                dangerouslySetInnerHTML={{
                  __html: cmspage.imageModels[0].description,
                }}
              ></p>
            )}
        </div>
      )}
    </header>
  );
};

TopPanel.propTypes = {
  meta: PropTypes.object,
};
